export const Claims = {
    Role: "http://schemas.microsoft.com/ws/2008/06/identity/claims/role",
    AppMetaData: "https://schemas.vetindependant/app_metadata"
}